import { JapanPrefecture } from '@/gql/generated/graphql'

export function contestImageShareText(params: {
  thinkingLevelText?: string
  isPreliminary: boolean
  jobName: string
}) {
  const heading = params.isPreliminary
    ? '思考力チャレンジの成績速報が届きました📣'
    : '思考力チャレンジの成績が届きました📣'
  const level = params.thinkingLevelText
    ? `思考力レベルは${params.thinkingLevelText}級${params.isPreliminary ? '（未確定）' : ''}！`
    : ''
  return `${heading}\n${level}秘められた才能は「${params.jobName}」でした✨`
}

export const snsShareRecommendedJobOptions = [
  {
    name: '宇宙飛行士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/astronaut',
    text: `思考力チャレンジの結果、あなたに向いている職業は「宇宙飛行士」でした！✨
高い空間認識力を活かして、未知の宇宙空間を自由自在に飛び回れるかも🚀`,
    hashTags: ['思考力チャレンジ', '職業分析', '宇宙飛行士', 'タブレット学習'],
  },
  {
    name: 'ふりつけ師',
    url: 'https://www.sonyged.com/logiq/job-aptitude/choreographer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ふりつけ師」でした！✨
空間認識力を活かして動きをデザインすることで、観る人の心を動かすような振り付けができるかも💃`,
    hashTags: ['思考力チャレンジ', '職業分析', 'ふりつけ師', 'タブレット学習'],
  },
  {
    name: '写真家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/photographer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「写真家」でした！✨
空間認識力と探索力を活かして、大事なシャッターチャンスをとらえて素敵な写真が撮れるかも📸`,
    hashTags: ['思考力チャレンジ', '職業分析', '写真家', 'タブレット学習'],
  },
  {
    name: 'アニメータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/animator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「アニメータ」でした！✨
探索力と空間認識力を活かして、人を笑顔にできるようなアニメーションがつくれるかも🎨`,
    hashTags: ['思考力チャレンジ', '職業分析', 'アニメータ', 'タブレット学習'],
  },
  {
    name: '化石研究員',
    url: 'https://www.sonyged.com/logiq/job-aptitude/fossil_researcher',
    text: `思考力チャレンジの結果、あなたに向いている職業は「化石研究員」でした！✨
探索力と空間認識力を駆使して、隠れた化石を探し出すことができちゃうかも🔍🦴`,
    hashTags: ['思考力チャレンジ', '職業分析', '化石研究員', 'タブレット学習'],
  },
  {
    name: '探てい',
    url: 'https://www.sonyged.com/logiq/job-aptitude/detective',
    text: `思考力チャレンジの結果、あなたに向いている職業は「探偵」でした！✨
探索することが特に得意なので、小さなヒントから真実を暴くことができちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '探偵', 'タブレット学習'],
  },
  {
    name: '探検家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/explorer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「探検家」でした！✨
探索力が抜群なので、未知の世界を切り拓いていけるかも🧭`,
    hashTags: ['思考力チャレンジ', '職業分析', '探検家', 'タブレット学習'],
  },
  {
    name: 'パイロット',
    url: 'https://www.sonyged.com/logiq/job-aptitude/pilot',
    text: `思考力チャレンジの結果、あなたに向いている職業は「パイロット」でした！✨
空間認識力が高く、広い空を自在に飛び回る才能があるかも🛫`,
    hashTags: ['思考力チャレンジ', '職業分析', 'パイロット', 'タブレット学習'],
  },
  {
    name: 'インテリアコーディネータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/interior_coordinator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「インテリアコーディネータ」でした！✨
空間認識力を活かして、おしゃれで使いやすい空間をデザインできるかも🏡`,
    hashTags: ['思考力チャレンジ', '職業分析', 'インテリアコーディネータ', 'タブレット学習'],
  },
  {
    name: 'ステージ演出家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/stage_director',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ステージ演出家」でした！✨
空間認識力と探索力を活かして、お芝居やダンスの舞台を鮮やかに演出できる才能があるかも🎭`,
    hashTags: ['思考力チャレンジ', '職業分析', '舞台演出家', 'タブレット学習'],
  },
  {
    name: '環境エンジニア',
    url: 'https://www.sonyged.com/logiq/job-aptitude/environmental_engineer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「環境エンジニア」でした！✨
探索力と空間認識力を活かして、自然や環境の課題を解決するエンジニアになれるかも🌿`,
    hashTags: ['思考力チャレンジ', '職業分析', '環境エンジニア', 'タブレット学習'],
  },
  {
    name: '考古学者',
    url: 'https://www.sonyged.com/logiq/job-aptitude/archaeologist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「考古学者」でした！✨
探索力を活かして、誰も知らない歴史を掘り起こせちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '考古学者', 'タブレット学習'],
  },
  {
    name: '発明家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/inventor',
    text: `思考力チャレンジの結果、あなたに向いている職業は「発明家」でした！✨
探索力を活かして、毎日の生活がもっと楽しくなる便利なものを発明できちゃうかも🔬`,
    hashTags: ['思考力チャレンジ', '職業分析', '発明家', 'タブレット学習'],
  },
  {
    name: '建築家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/architect',
    text: `思考力チャレンジの結果、あなたに向いている職業は「建築家」でした！✨
空間認識力を活かして、かっこよく快適な建物を設計できるかも🏢`,
    hashTags: ['思考力チャレンジ', '職業分析', '建築家', 'タブレット学習'],
  },
  {
    name: 'ゲームクリエータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/game_creator',
    text: `思考力チャレンジの結果、あなたに向いている職業は
「ゲームクリエイター」でした！✨
空間認識力と情報読解力を活かして、みんなが楽しめる新しいゲームをつくり出せるかも🎯`,
    hashTags: ['思考力チャレンジ', '職業分析', 'ゲームクリエイター', 'タブレット学習'],
  },
  {
    name: '絵本作家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/picture_book_author',
    text: `思考力チャレンジの結果、あなたに向いている職業は「絵本作家」でした！✨
空間認識力、情報読解力、探索力をバランス良く活かして、想像力豊かなワクワクする物語をつくれるかも📚`,
    hashTags: ['思考力チャレンジ', '職業分析', '絵本作家', 'タブレット学習'],
  },
  {
    name: '脳科学者',
    url: 'https://www.sonyged.com/logiq/job-aptitude/neuroscientist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「脳科学者」でした！✨
情報読解力と探索力を活かして、脳の仕組みを解明できちゃうかも🧠🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '脳科学者', 'タブレット学習'],
  },
  {
    name: 'データサイエンティスト',
    url: 'https://www.sonyged.com/logiq/job-aptitude/data_scientist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「データサイエンティスト」でした！✨
探索力と情報読解力を活かして、データに隠れた大事なヒントを見つけ出せるかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', 'データサイエンティスト', 'タブレット学習'],
  },
  {
    name: '外科医',
    url: 'https://www.sonyged.com/logiq/job-aptitude/surgeon',
    text: `思考力チャレンジの結果、あなたに向いている職業は「外科医」でした！✨
情報読解力と空間認識力を活かして、病気やけがを治す人になれるかも💉`,
    hashTags: ['思考力チャレンジ', '職業分析', '外科医', 'タブレット学習'],
  },
  {
    name: 'フードコーディネータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/food_coordinator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「フードコーディネータ」でした！✨
情報読解力と空間認識力を活かして、美味しい料理を素敵に盛り付けられるかも🍽️🌟`,
    hashTags: ['思考力チャレンジ', '職業分析', 'フードコーディネータ', 'タブレット学習'],
  },
  {
    name: '起業家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/entrepreneur',
    text: `思考力チャレンジの結果、あなたに向いている職業は「起業家」でした！✨
情報読解力と探索力を活かして、新しいお店や会社をつくれちゃうかも🚀`,
    hashTags: ['思考力チャレンジ', '職業分析', '起業家', 'タブレット学習'],
  },
  {
    name: 'ジャーナリスト',
    url: 'https://www.sonyged.com/logiq/job-aptitude/journalist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ジャーナリスト」でした！✨
情報読解力と探索力を活かして、ニュースや出来事をわかりやすく伝えることができるかも📰`,
    hashTags: ['思考力チャレンジ', '職業分析', 'ジャーナリスト', 'タブレット学習'],
  },
  {
    name: '航海士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/navigator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「航海士」でした！✨
情報読解力と空間認識力を活かして、地図や天気を正確に読み取って航路を導き出るかも🧭`,
    hashTags: ['思考力チャレンジ', '職業分析', '航海士', 'タブレット学習'],
  },
  {
    name: '科学そうさ官',
    url: 'https://www.sonyged.com/logiq/job-aptitude/science_investigator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「科学捜査官」でした！✨
情報読解力を活かして、現場の証拠から真実を解明できちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '科学捜査官', 'タブレット学習'],
  },
  {
    name: 'プログラマー',
    url: 'https://www.sonyged.com/logiq/job-aptitude/programmer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「プログラマー」でした！✨
情報読解力と探索力を活かしてコンピュータに指示を出し、ゲームやアプリを開発できるかも💻🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', 'プログラマー', 'タブレット学習'],
  },
  {
    name: '航空管制官',
    url: 'https://www.sonyged.com/logiq/job-aptitude/air_traffic_controller',
    text: `思考力チャレンジの結果、あなたに向いている職業は「航空管制官」でした！✨
情報読解力と空間認識力を活かして、安全な空の交通を支えられるかも✈️🚦`,
    hashTags: ['思考力チャレンジ', '職業分析', '航空管制官', 'タブレット学習'],
  },
  {
    name: '弁護士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/lawyer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「弁護士」でした！✨
情報読解力を活かして、法律や物事を正しく読み解いて問題を解決できるかも⚖️`,
    hashTags: ['思考力チャレンジ', '職業分析', '弁護士', 'タブレット学習'],
  },
  {
    name: '新聞記者',
    url: 'https://www.sonyged.com/logiq/job-aptitude/newspaper_reporter',
    text: `思考力チャレンジの結果、あなたに向いている職業は「新聞記者」でした！✨
高い情報読解力を活かして、いろいろな出来事を新聞を通して正確にわかりやすく伝えられるかも📰`,
    hashTags: ['思考力チャレンジ', '職業分析', '新聞記者', 'タブレット学習'],
  },
]

export const prefectureOptionsMap = {
  ['HOKKAIDO']: '北海道',
  ['AOMORI']: '青森県',
  ['IWATE']: '岩手県',
  ['MIYAGI']: '宮城県',
  ['AKITA']: '秋田県',
  ['YAMAGATA']: '山形県',
  ['FUKUSHIMA']: '福島県',
  ['IBARAKI']: '茨城県',
  ['TOCHIGI']: '栃木県',
  ['GUNMA']: '群馬県',
  ['SAITAMA']: '埼玉県',
  ['CHIBA']: '千葉県',
  ['TOKYO']: '東京都',
  ['KANAGAWA']: '神奈川県',
  ['NIIGATA']: '新潟県',
  ['TOYAMA']: '富山県',
  ['ISHIKAWA']: '石川県',
  ['FUKUI']: '福井県',
  ['YAMANASHI']: '山梨県',
  ['NAGANO']: '長野県',
  ['GIFU']: '岐阜県',
  ['SHIZUOKA']: '静岡県',
  ['AICHI']: '愛知県',
  ['MIE']: '三重県',
  ['SHIGA']: '滋賀県',
  ['KYOTO']: '京都府',
  ['OSAKA']: '大阪府',
  ['HYOGO']: '兵庫県',
  ['NARA']: '奈良県',
  ['WAKAYAMA']: '和歌山県',
  ['TOTTORI']: '鳥取県',
  ['SHIMANE']: '島根県',
  ['OKAYAMA']: '岡山県',
  ['HIROSHIMA']: '広島県',
  ['YAMAGUCHI']: '山口県',
  ['TOKUSHIMA']: '徳島県',
  ['KAGAWA']: '香川県',
  ['EHIME']: '愛媛県',
  ['KOCHI']: '高知県',
  ['FUKUOKA']: '福岡県',
  ['SAGA']: '佐賀県',
  ['NAGASAKI']: '長崎県',
  ['KUMAMOTO']: '熊本県',
  ['OITA']: '大分県',
  ['MIYAZAKI']: '宮崎県',
  ['KAGOSHIMA']: '鹿児島県',
  ['OKINAWA']: '沖縄県',
} as const

export const contestAttemptAgeGroupOptions = {
  ['P1']: '年少以下',
  ['P2']: '年中',
  ['P3']: '年長',
  ['E1']: '小学1年生',
  ['E2']: '小学2年生',
  ['E3']: '小学3年生',
  ['E4']: '小学4年生',
  ['E5']: '小学5年生',
  ['E6']: '小学6年生',
  ['J1']: '中学1年生',
  ['J2']: '中学2年生',
  ['J3']: '中学3年生',
  ['PRESCHOOL']: '未就学',
  ['ELEMENTARY_SCHOOL']: '小学生',
  ['JUNIOR_HIGH_SCHOOL']: '中学生',
  ['HIGH_SCHOOL']: '高校生',
  ['GENERAL']: '一般',
  ['AGE_LTE_10']: '10歳未満(0-9)',
  ['AGE_10S']: '10代',
  ['AGE_20S']: '20代',
  ['AGE_30S']: '30代',
  ['AGE_40S']: '40代',
  ['AGE_50S']: '50代',
  ['AGE_GTE_60']: '60代以上',
  ['AGE_60_TO_74']: '60歳〜74歳',
  ['AGE_GTE_75']: '75歳以上',
} as const
